module.exports = __webpack_public_path__ + "static/microsoft-powerapps-enable-e026b2e338f801f24ce8b23e03721d4f.png";